<template>
  <svg>
    <path :d="`${start} ${curvature} ${end}`"  stroke="white" stroke-width="5" stroke-linecap="round" fill="transparent"/>
    <polyline :points="`${points}`" stroke="white" stroke-width="5" stroke-linecap="round" fill="none" stroke-linejoin="round"/>
 </svg>
</template>

<script>
export default {
    name: 'Arrow',
    props: ['start', 'end', 'curvature', 'points']
}
</script>

<style>

</style>